import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';

export const SubsectionSummary = ({ name, quantityLabel }) => {
  return (
    <div className={styles.SubsectionSummary}>
      <span className={styles.name}>{name}</span>
      <span className={styles.quantity}>{quantityLabel}</span>
    </div>
  );
};

SubsectionSummary.propTypes = {
  name: PropTypes.string.isRequired,
  quantityLabel: PropTypes.string.isRequired,
};

export default enhance(SubsectionSummary);
